import FiscalPeriodLabel from './FiscalPeriodLabel';
import { fiscalPeriodPropTypes } from './constants';

export default FiscalPeriodLabel;
export { fiscalPeriodPropTypes };
